import * as types from './mutation-types'
import { requestUtils } from '../../helpers'

const state = {
  list: []
}

const getters = {
  getCardTypes (state) {
    return state.list
  }
}

const actions = {
  loadCardTypes ({ commit, rootGetters }) {
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.get('/card_types', null, headers)
      .then((response) => {
        commit(types.SET_CARD_TYPES, response.data)
        return response
      })
  }
}

const mutations = {
  [types.SET_CARD_TYPES] (state, list) {
    state.list = list
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/card_type.js